import React from 'react';
import LessonHome from '../LessonHome';

const Lesson1 = (props) => {

    return ( 
        <LessonHome
            {...props}
        />        
     );
}
 
export default Lesson1;